module.exports = __webpack_public_path__ + "assets/0b040ed031b2fb5ab3a24f1646edbc5e.png";